import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Layout, Col, Row, Tabs } from "antd";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { URL } from "../00_Nav/url";
import { TABS_ACTIVE } from "../../store/string";

//style
import "./style.css";

// component
import LayoutBreadCrumb from "../00_Nav/layout/layout_bread_crumb";
import SectionTitle from "../../component/section_title";
import BranchShopEdit from "../02_Branch_Tab_Shop/branch_shop_edit";
import BranchPayment from "../02_Branch_Tab_Payment/branch_payment";
import BranchStaff from "../02_Branch_Tab_Staff/branch_staff";
import BranchAccess from "../02_Branch_Tab_Access/branch_access";
import BranchVoucher from "../02_Branch_Tab_Voucher/branch_voucher";
import StaffDetail from "./component/staff_detail";

// redux
import { snapDetail, unSnapDetail } from "../../store/branch/branch.action";

const { Content } = Layout;
const { TabPane } = Tabs;

const BranchStaffDetail = () => {
  // -------------------------- VAR --------------------------
  const navigate = useNavigate();
  const params = useParams();
  const id = params.id;

  const href = `/branchs/detail/${id}/staff/`;
  const breadCrumb = [
    { title: "Home", url: URL.home },
    { title: "Branchs", url: URL.home },
    { title: "Details", url: href },
    { title: "Edit Staff", url: null },
  ];

  // -------------------------- STATE --------------------------
  const [loading, setLoading] = useState(true);
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  // -------------------------- FUNCTION --------------------------
  const onChangeTab = (key) => {
    const type =
      TABS_ACTIVE?.find((item) => item?.key === key)?.route || "shop";
    console.log("key", key);
    const href = `/branchs/detail/${id}/${type}/`;
    navigate(href);
  };
  // -------------------------- EFFECT --------------------------
  useEffect(() => {
    dispatch(
      snapDetail({ id }, () => {
        setLoading(false);
      })
    );
    return () => {
      dispatch(unSnapDetail());
    };
  }, [dispatch, id]);
  // -------------------------- DATA FUNCTION --------------------------
  // -------------------------- RENDER --------------------------

  const renderBody = () => {
    return (
      <Row justify="end" align="middle" gutter={[16, 16]}>
        <Col lg={24} md={24} sm={24} xs={24}>
          <Tabs
            onChange={onChangeTab}
            defaultActiveKey="3"
            type="card"
            size="large"
          >
            <TabPane tab="Shop" disabled={loading} key="1">
              <BranchShopEdit />
            </TabPane>
            <TabPane tab="Payment" disabled={loading} key="2">
              <BranchPayment />
            </TabPane>
            <TabPane tab="Staff" disabled={loading} key="3">
              <StaffDetail />
            </TabPane>
            <TabPane tab="Access" disabled={loading} key="4">
              <BranchAccess />
            </TabPane>
            <TabPane tab="Voucher" disabled={loading} key="5">
              <BranchVoucher />
            </TabPane>
          </Tabs>
        </Col>
      </Row>
    );
  };

  // -------------------------- MAIN --------------------------

  return (
    <Layout className="site-layout full">
      <Content className="content page-content">
        <LayoutBreadCrumb data={breadCrumb} />
        <SectionTitle
          title="Shop Details"
          subtitle="Basic information about your bussiness"
        />
        {renderBody()}
      </Content>
    </Layout>
  );
};

export default BranchStaffDetail;
